import { TestimonialGrid } from "~/components/index"

export {}

let loaded = false

const init = async () => {
    if (loaded) return
    loaded = true
    const { default: Alpine } = await import("alpinejs")
    const { default: AlpinePersist } = await import("@alpinejs/persist")
    const { default: AlpineIntersect } = await import("@alpinejs/intersect")
    const { default: AlpineMorph } = await import("@alpinejs/morph")
    const { default: AlpineHistory } = await import("~/plugins/history")
    const { default: AlpineNavigate } = await import("~/plugins/navigate/index")

    const {
        FeaturedProduct,
        AddToCart,
        Cart,
        ProductForm,
        ProductFormGift,
        ProductGallery,
        ProductBundle,
        ProductSection,
        ProductFormSimple,
        Collection,
        CollectionMenu,
        BackInStock,
        FeaturedCollectionSlider,
        SocialCarousel,
        ReploProduct,
        ProductSectionPDP,
        SingleCollectionSlider,
        SecretCollectionSlider,
        Membership,
        MembershipSignup,
        Login,
        AccountPortal,
        MembershipTier,
        ProductFormUniversal,
        TestimonialGrid,
        ProductSimple,
        SignupForm,
        FounderSection,
        MembershipNew,
        TrialLander
    } = await import("~/components/index")

    Alpine.plugin(FeaturedProduct)
    Alpine.plugin(AlpinePersist)
    Alpine.plugin(AlpineIntersect)
    Alpine.plugin(AlpineMorph)
    Alpine.plugin(AlpineHistory)
    Alpine.plugin(AlpineNavigate)
    Alpine.plugin(ProductForm)
    Alpine.plugin(ProductFormGift)
    Alpine.plugin(ProductGallery)
    Alpine.plugin(AddToCart)
    Alpine.plugin(Cart)
    Alpine.plugin(ProductBundle)
    Alpine.plugin(ProductSection)
    Alpine.plugin(ProductFormSimple)
    Alpine.plugin(Collection)
    Alpine.plugin(CollectionMenu)
    Alpine.plugin(BackInStock)
    Alpine.plugin(FeaturedCollectionSlider)
    Alpine.plugin(SocialCarousel)
    Alpine.plugin(ReploProduct)
    Alpine.plugin(ProductSectionPDP)
    Alpine.plugin(SingleCollectionSlider)
    Alpine.plugin(SecretCollectionSlider)
    Alpine.plugin(Membership)
    Alpine.plugin(MembershipSignup)
    Alpine.plugin(Login)
    Alpine.plugin(AccountPortal)
    Alpine.plugin(MembershipTier)
    Alpine.plugin(ProductFormUniversal)
    Alpine.plugin(TestimonialGrid)
    Alpine.plugin(ProductSimple)
    Alpine.plugin(SignupForm)
    Alpine.plugin(FounderSection)
    Alpine.plugin(MembershipNew)
    
    Alpine.plugin(TrialLander)

    Alpine.store("mobileMenu", {
        isOpen: false,
        toggle() {
            this.isOpen = !this.isOpen
            if (this.isOpen) {
                document.body.classList.add("freeze-scroll")
            } else {
                document.body.classList.remove("freeze-scroll")
            }
        },
        close() {
            this.isOpen = false
            this.updateBodyScroll()
        },
        updateBodyScroll() {
            if (this.isOpen) {
                document.body.classList.add("freeze-scroll")
            } else {
                document.body.classList.remove("freeze-scroll")
            }
        },
    })

    Alpine.store("variant", {
        id: null,
        price: null,
        priceFormatted: null,
        qty: null,
        itemQty: null,
        selectedVariant: null,
        sellingPlanPrice: null,

        subscribeActive: null,
        variantQty: null,
        variantOriginalPrice: null,
        variantOriginalPriceFormatted: null,
        variantIsAvailable: null,
        variantCurrentPrice: null,
        variantCurrentPriceFormatted: null,
        variantDiscount: null,
        variantDiscountPercent: null,
        variantSubscriptionDiscount: null,
        variantSubscriptionDiscountFormatted: null,
        variantSubscriptionDiscountPercent: null,
        simplePrice: null,
        qtyMessage: null,
        stickyATC: null,
    })

    Alpine.data("slider", (props) => ({
        async init() {
            const { default: BlazeSlider } = await import("blaze-slider")
            new BlazeSlider(this.$el, {
                all: {
                    enableAutoplay: true,
                    slidesToShow: 1,
                    draggable: true,
                    loop: true,
                    slideGap: "0px",
                    slidesToScroll: 1,
                },
            })
        },
    }))
    Alpine.data("reviewsSlider", () => ({
        enableAutoplay: true,
        slidesToShow: 1,
        draggable: true,
        loop: true,
        slideGap: "0px",
        slidesToScroll: 1,
        pageIndex: 0,
        async init() {
            const { default: BlazeSlider } = await import("blaze-slider")
            this.blazeSlider = new BlazeSlider(this.$el)
            let sliderButtons = this.$el.querySelectorAll('.slider-button')

            this.blazeSlider.onSlide((pageIndex) => {
                // this.updatePagination(pageIndex)
                this.pageIndex = pageIndex

                sliderButtons.forEach((button, index) => {
                    if (index === pageIndex) {
                        button.classList.add('active')
                    } else {
                        button.classList.remove('active')
                    }
                })

            })
        },
        changeSlides(index) {
            if (this.pageIndex >= index) {
                this.blazeSlider.prev(this.pageIndex - index)
            } else {
                this.blazeSlider.next(index - this.pageIndex)
            }
        },
        onFormSubmit(event) {
            console.log(event)
            event.preventDefault()

            // Get form data
            const formData = new FormData(event.target)

            // Post form data to cart/add.js
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    },
                body: JSON.stringify(Object.fromEntries(formData)),
            })
            .then((response) => response.json())
            .then((data) => {
                Alpine.store("cart").load()
                this.$dispatch("cart-updated", data)
                Alpine.store("cart").open = true
            })
            .catch((error) => {
                console.error("Error:", error)
            })
        }
    }))

    Alpine.data("announcementSlider", (props) => ({
        async init() {
            const { default: BlazeSlider } = await import("blaze-slider")
            new BlazeSlider(this.$el, {
                all: {
                    enableAutoplay: true,
                    slidesToShow: 1,
                    draggable: true,
                    loop: true,
                    slideGap: "0px",
                    slidesToScroll: 1,
                },
            })
        },
    }))

    function convertNewlinesToBreaks() {
        const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null)
      
        let node
        while ((node = walker.nextNode())) {
          if (node.nodeValue && node.nodeValue.includes("\\n")) {
            const span = document.createElement("span")
            span.innerHTML = node.nodeValue.replace(/\\n/g, "<br>")
            node.parentNode?.replaceChild(span, node)
          }

          if (node.nodeValue && node.nodeValue.includes("<u>")) {
            const span = document.createElement("span")
            span.innerHTML = node.nodeValue.replace(/<u>/g, "<u class='underline'>")
            node.parentNode?.replaceChild(span, node)
          }
        }
      } 

    Alpine.start()
    convertNewlinesToBreaks()
    window.Alpine = Alpine
}

document.addEventListener("mousedown", init, { once: true })
document.addEventListener("mousemove", init, { once: true })
document.addEventListener("scroll", init, { once: true })
document.addEventListener("touchstart", init, { once: true })
document.addEventListener("keydown", init, { once: true })

// init()
